exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".logo{text-align:center}.logo-panel{margin-top:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-05147b6f!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/LoginView.vue
// module id = 358
// module chunks = 0